import createIcon from '../../createIcon';

/**
 * @component @name DoneAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuOTY1IDYuNzA1MDRMMTYuNTU1IDUuMjk1MDRMMTAuMjE1IDExLjYzNUwxMS42MjUgMTMuMDQ1TDE3Ljk2NSA2LjcwNTA0Wk0yMi4yMDUgNS4yOTUwNEwxMS42MjUgMTUuODc1TDcuNDQ1IDExLjcwNUw2LjAzNSAxMy4xMTVMMTEuNjI1IDE4LjcwNUwyMy42MjUgNi43MDUwNEwyMi4yMDUgNS4yOTUwNFpNMC4zNzUgMTMuMTE1TDUuOTY1IDE4LjcwNUw3LjM3NSAxNy4yOTVMMS43OTUgMTEuNzA1TDAuMzc1IDEzLjExNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoneAll = createIcon('DoneAll', [
  [
    'path',
    {
      d: 'M17.965 6.70504L16.555 5.29504L10.215 11.635L11.625 13.045L17.965 6.70504ZM22.205 5.29504L11.625 15.875L7.445 11.705L6.035 13.115L11.625 18.705L23.625 6.70504L22.205 5.29504ZM0.375 13.115L5.965 18.705L7.375 17.295L1.795 11.705L0.375 13.115Z',
      key: '1x10y6',
    },
  ],
]);

export default DoneAll;
